import { Inject, Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DepartmentService } from '../../../services/department.service';
import { Department } from '../../../models/department';

/**
 * Dialog Data
 */
export interface DialogData {
  /**
   * Department
   */
  departmentId: number;
}

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class DepartmentEditComponent implements OnInit {
  /**
   * Is creating
   */
  isCreating: boolean;

  /**
   * Department form
   */
  departmentForm: FormGroup;

  /**
   * Department
   */
  department: Department;

  constructor(
    public dialogRef: MatDialogRef<DepartmentEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private departmentService: DepartmentService
  ) {}

  ngOnInit(): void {
    this.departmentForm = new FormGroup({
      description: new FormControl(null, [Validators.required, Validators.maxLength(45)]),
      emails: new FormControl(null, Validators.maxLength(255)),
      mobiles: new FormControl(null, Validators.maxLength(255)),
    });

    if (this.data) {
      this.departmentService.findFiltered({ id: this.data.departmentId }).subscribe((department: any) => {
        if (department.length > 0) {
          this.department = department[0];
          this.isCreating = false;
          for (const i in this.departmentForm.controls) {
            if (this.departmentForm.controls.hasOwnProperty(i)) {
              this.departmentForm.controls[i].setValue(this.department[i]);
            }
          }
        }
      });
    } else {
      this.department = new Department();
      this.isCreating = true;
    }
  }

  /**
   * Save department form
   */
  save(): void {
    for (const i in this.departmentForm.controls) {
      if (this.departmentForm.controls.hasOwnProperty(i) && this.departmentForm.controls[i].value !== null) {
        this.department[i] = this.departmentForm.controls[i].value;
      }
    }
    if (this.isCreating) {
      this.departmentService.create(this.department).subscribe(() => this.dialogRef.close({}));
    } else {
      this.departmentService.update(this.department).subscribe(() => this.dialogRef.close({}));
    }
  }

  /**
   * Close dialog
   */
  close(): void {
    this.dialogRef.close();
  }
}
